import { RouteRecordRaw } from 'vue-router';
import { AuthGuardService } from '@/_guard/AuthGuardService';

import gamesLayout from '@/modules/games/views/viewGamesIndex.vue';
import listGame from '@/modules/games/views/viewGamesList.vue';
import updateGame from '@/modules/games/views/viewGamesUpdate.vue';
import gamePreview from '@/modules/games/views/viewGamesPreview.vue';
import gamePlay from '@/modules/games/views/viewGamesPlay.vue';

const auth = new AuthGuardService();

export const GamesRoutes: RouteRecordRaw[] = [
  {
    path: '/gameslayout',
    name: 'viewGamesIndex',
    component: gamesLayout,
    beforeEnter: auth.guard,
    children: [
      {
        path: '/games',
        name: 'viewGamesList',
        meta: {title: 'Games'},
        component: listGame
      },
      {
        path: '/game-preview/:gameId',
        name: 'viewGamesPreview',
        meta: {title: 'Preview Game'},
        props: true,
        component: gamePreview
      },
      {
        path: '/update-game/:gameId',
        name: 'viewGamesUpdate',
        meta: {title: 'Update Game'},
        props: true,
        component: updateGame
      },
      {
        path: '/game-play/:gameId',
        name: 'viewGamesPlay',
        meta: {title: 'Game Arena'},
        props: true,
        component: gamePlay
    },
    ],
  },
];
